// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyD878AFTCeESE8LxtykvS81MhbErSFa2Os',
  authDomain: 'ronghaorobot.firebaseapp.com',
  projectId: 'ronghaorobot',
  storageBucket: 'ronghaorobot.appspot.com',
  messagingSenderId: '729578056206',
  appId: '1:729578056206:web:d7519f6bfc3ce7d91b6a5f',
  measurementId: 'G-CZQD9B2EQJ',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)
